import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Badge } from 'react-bootstrap';
import { useParams, Link } from 'react-router-dom';
import api from '../services/api';

const ServiceDetail = () => {
  const { slug } = useParams();
  const [service, setService] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadService();
  }, [slug]);

  const loadService = async () => {
    try {
      const response = await api.get(`/services/${slug}/`);
      setService(response.data);
    } catch (error) {
      console.error('Error loading service:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Container className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </Container>
    );
  }

  if (!service) {
    return (
      <Container className="py-5">
        <h1>Service Not Found</h1>
        <Link to="/services" className="btn btn-primary">Back to Services</Link>
      </Container>
    );
  }

  return (
    <Container className="py-5">
      <Row>
        <Col lg={8}>
          <h1 className="page-title">{service.name}</h1>
          <div dangerouslySetInnerHTML={{ __html: service.description }} />
          
          {service.how_to_apply && (
            <Card className="mt-4">
              <Card.Header className="bg-primary text-white">
                <h5 className="mb-0">How to Apply</h5>
              </Card.Header>
              <Card.Body dangerouslySetInnerHTML={{ __html: service.how_to_apply }} />
            </Card>
          )}
          
          {service.required_documents && (
            <Card className="mt-4">
              <Card.Header className="bg-info text-white">
                <h5 className="mb-0">Required Documents</h5>
              </Card.Header>
              <Card.Body dangerouslySetInnerHTML={{ __html: service.required_documents }} />
            </Card>
          )}
        </Col>
        <Col lg={4}>
          <Card className="mb-4">
            <Card.Header className="bg-primary text-white">
              <h5 className="mb-0">Service Information</h5>
            </Card.Header>
            <Card.Body>
              {service.fees && (
                <p><strong>Fees:</strong> <Badge bg="success">{service.fees}</Badge></p>
              )}
              {service.processing_time && (
                <p><strong>Processing Time:</strong> {service.processing_time}</p>
              )}
              {service.department_name && (
                <p><strong>Department:</strong> {service.department_name}</p>
              )}
              {service.online_application_url && (
                <a href={service.online_application_url} className="btn btn-primary w-100" target="_blank" rel="noopener noreferrer">
                  Apply Online
                </a>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ServiceDetail;
